import React from "react";
import { Avatar, Select, Tooltip } from "antd";
import classNames from "classnames";
import { generateUniqueColor } from "utils";

import styles from "./styles.module.scss";

const SelectMultiple = _props => {
  const {
    type,
    options,
    value,
    noAllowClear,
    selectKeyValue,
    config,
    placeholder,
    selectKeyLabel,
    tagRender: TagRender,

    onChange = () => {},
  } = _props;
  const filterOption = (input, option) => {
    return (
      (option?.label ?? "").toLowerCase().includes(input.toLowerCase()) ||
      (option?.value ?? "").toLowerCase().includes(input.toLowerCase())
    );
  };
  return (
    <Select
      mode={config.mode}
      defaultOpen={false}
      showSearch={type === "select-search"}
      allowClear={!noAllowClear}
      value={value}
      defaultValue={value}
      onChange={_value => {
        if (config.getObject) {
          onChange(options.find(dt => dt[selectKeyValue] === _value));
        } else {
          onChange(_value);
        }
      }}
      onSearch={config.onSearch}
      placeholder={placeholder}
      disabled={config?.disabled}
      style={{
        width: config?.width,
        padding: "0",
        textAlign: "start",
        height: "auto",
      }}
      className={classNames({
        [styles.wrapSelect]: true,
      })}
      tagRender={_tagProps => {
        return <TagRender {..._tagProps} options={options} />;
      }}
      filterOption={filterOption}
    >
      {options.map((option, index) => (
        <Select.Option
          key={index.toString() + option[selectKeyLabel]}
          value={option.id}
          disabled={option.disabled}
          label={option.label}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 16,
            }}
          >
            {typeof option.src === "string" && (
              <Avatar
                style={{
                  backgroundColor: option.src
                    ? "#fff"
                    : generateUniqueColor(option.label),
                  color: "#fff",
                  textTransform: "uppercase",
                }}
                src={option.src}
              >
                {option.src ? "" : option.label.charAt(0)}
              </Avatar>
            )}
            {typeof option.src === "function" && (
              <Avatar
                style={{
                  color: "#fff",
                  textTransform: "uppercase",
                }}
                icon={option.src()}
              >
                {option.src ? "" : option.label.charAt(0)}
              </Avatar>
            )}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                width: 650,
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
              }}
            >
              <Tooltip title={option.label}>
                <span style={{ fontWeight: config?.style?.fontWeight || 700 }}>
                  {option.label}
                </span>
              </Tooltip>
              <span>{option.phone}</span>
            </div>
          </div>
        </Select.Option>
      ))}
    </Select>
  );
};

export default SelectMultiple;
